import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=3dc583c3&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&id=3dc583c3&prod&lang=css"
import style1 from "./ClientInfo.vue?vue&type=style&index=1&id=3dc583c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc583c3",
  null
  
)

export default component.exports